// User types for the frontend application

export interface User {
	id: number;
	active: boolean;
	email: string;
	nome: string;
	cognome: string;
	telefono: string;
	role: UserRole;
	ragione_sociale: string;
	partita_iva: string;
	codice_fiscale: string;
	codice_destinatario?: string;
	sede_legale?: UserAddress;
	sede_operativa?: UserAddress[];
	pec: string;
	paga_provvigioni: boolean;
	esternalizza_fasi: boolean;
	email_confirmed: boolean;
	email_verification_token?: string;
	email_verification_expires?: string;
	password_reset_token?: string;
	password_reset_expires?: string;
	xbrl_file_key?: string;
	xbrl_file_name?: string;
	other_format_file_key?: string;
	other_format_file_name?: string;
	createdAt: string;
	updatedAt: string;
}

export enum UserRole {
	USER = "user",
	ADMIN = "admin"
}

export interface UserAddress {
	indirizzo: string;
	citta: string;
	provincia: string;
	cap: string;
	paese: string;
}

// User profile update interface
export interface UpdateUserProfile {
	nome?: string;
	cognome?: string;
	email?: string;
	telefono?: string;
	ragione_sociale?: string;
	partita_iva?: string;
	codice_fiscale?: string;
	codice_destinatario?: string;
	sede_legale?: UserAddress;
	sede_operativa?: UserAddress[];
	pec?: string;
	paga_provvigioni?: boolean;
	esternalizza_fasi?: boolean;
}

// User registration interface
export interface RegisterUser {
	email: string;
	password: string;
	nome: string;
	cognome: string;
	telefono: string;
	ragione_sociale: string;
	partita_iva: string;
	codice_fiscale: string;
	codice_destinatario?: string;
	sede_legale?: UserAddress;
	sede_operativa?: UserAddress[];
	pec: string;
	paga_provvigioni: boolean;
	esternalizza_fasi: boolean;
	xbrl_file?: File;
	xbrl_file_name?: string;
	other_format_file?: File;
	other_format_file_name?: string;
}

// Union type for registration that can handle both object and FormData
export type RegistrationData = RegisterUser | FormData;

// User login interface
export interface LoginUser {
	email: string;
	password: string;
}

// User response from API
export interface UserResponse {
	user: User;
	access_token: string;
}

// User list response for admin
export interface UserListResponse {
	users: User[];
	total: number;
	page: number;
	limit: number;
	totalPages: number;
}

// User statistics (for future use)
export interface UserStats {
	totalUsers: number;
	activeUsers: number;
	verifiedUsers: number;
	adminUsers: number;
}

// User preferences (for future use)
export interface UserPreferences {
	language: string;
	timezone: string;
	notifications: {
		email: boolean;
		push: boolean;
		sms: boolean;
	};
	theme: "light" | "dark" | "auto";
}
